module.exports = __webpack_public_path__ + "img/no-image.e23bf96.png";